/* ------------------------------------------------------------------------ */
/*		File: cmpPolicy.d.ts                                                */
/*		Description: Component interface definition                         */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


export enum TTypeItem {
    GROUP = "group",
    BULLET = "bullet",
    PARAGRAPH = "paragraph",
    IMAGE = "image",
}

export interface ICmpPolicy {
    position?: number                       // Position of the element in the array
    label?: string,                         // Title
    description?: string,                   // Detail of the content
    type?: string,                          // Type of content
    src?: string,                           // Link of the icon / image
    content?: ICmpPolicy[]                  // Array of elements
}

export interface ICard {
    card: ICmpPolicy,
}